import { useQuery, useQueryClient } from '@tanstack/react-query';
import { createFileRoute, useParams } from '@tanstack/react-router';
import { Connectivity, PentaDashboard } from '@volvogroup-internal/dashboard';
import { useTranslation } from 'react-i18next';

import Table from '@/components/Table';
import { getToken } from '@/config/MsalAuthConfig';
import { useFleetAccount } from '@/contexts/fleet-account/useFleetAccount';
import {
  getAllFleetUnitsQueryOptions,
  getUnitsConnectivityStatusQueryOptions,
  getUnitsLastSeenQueryOptions,
} from '@/service/vpc/queryOptions';
import { client } from '@/service/vpc/vpcService';
import useConnectivityTable, { mapConnectivityTableData } from '@/tables/useConnectivityTable';

export const Route = createFileRoute('/_authenticated/_account/fleets/$fleetId/dashboard/connectivity/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { fleetId } = useParams({
    from: '/_authenticated/_account/fleets/$fleetId/dashboard/connectivity/',
  });
  const { i18n, t } = useTranslation();
  const queryClient = useQueryClient();

  const { isLoading: isFleetUnitsLoading, fleetAccountUnits } = useFleetAccount();
  const { columns } = useConnectivityTable();

  const { data: fleetUnits, isLoading: isfleetUnitsLoading } = useQuery(getAllFleetUnitsQueryOptions({ fleetId }));

  const endCustomerUnitIds = fleetUnits?.items.map((unit) => Number(unit.endCustomerUnitId)) || [];
  const filteredUnits = fleetAccountUnits?.filter((unit) => endCustomerUnitIds?.includes(unit.endCustomerUnitId));

  const { data, isLoading } = useQuery(getUnitsLastSeenQueryOptions({ endCustomerUnitIds }));
  const { data: connectivityStatusData } = useQuery(getUnitsConnectivityStatusQueryOptions({ endCustomerUnitIds }));

  const tableData = mapConnectivityTableData(data, connectivityStatusData, filteredUnits || []);

  return (
    <div className="flex flex-col gap-6">
      <PentaDashboard
        client={{
          httpClient: {
            instance: client,
            getToken: getToken,
          },
          queryClient,
        }}
        language={i18n.language}
        preFilterUnits={endCustomerUnitIds}
        showFilterBar={false}
        showFilterMenu={false}
      >
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <Connectivity endCustomerUnitIds={endCustomerUnitIds} />
        </div>
      </PentaDashboard>
      <Table
        headerTitle={t(($) => $.pages.account.dashboard.connectivity.units_title)}
        isLoading={isFleetUnitsLoading || isfleetUnitsLoading || isLoading}
        data={tableData}
        columns={columns}
        showSearch={true}
        defaultSorting={[
          {
            id: 'lastSeen',
            desc: false,
          },
        ]}
      />
    </div>
  );
}
